<template>
    <svg width="88" height="56" viewBox="0 0 88 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1141_3659)">
        <rect x="5.82959" y="5.82959" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="5.82959" y="25.1471" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="5.82959" y="44.4646" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="32.0889" y="5.82959" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="32.0889" y="25.1471" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="32.0889" y="44.4646" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="58.3491" y="5.82959" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="58.3491" y="25.1471" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        <rect x="58.3491" y="44.4646" width="23.5433" height="16.9029" rx="1.20735" fill="#E0E0E0"/>
        </g>
        <rect x="0.6" y="0.6" width="86.8" height="54.8" rx="2.4" stroke="#DCDCDC" stroke-width="0.8"/>
        <defs>
        <clipPath id="clip0_1141_3659">
        <rect x="1" y="1" width="86" height="54" rx="2" fill="white"/>
        </clipPath>
        </defs>
    </svg>
</template>